import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Language } from 'src/app/modules/core/languages/language.model';
import { TZone, TimezoneService } from 'src/app/modules/core/services/time-zone.service';
import * as fromPrefs from '../../store';
import { Dataset, View, ViewComponent, ViewControlType } from '@app/modules/core/store/models';
import { DynamicField } from '@app/modules/core/components/fields/dynamic-field';
import { GUID_EMPTY } from '@app/core/constants';
import { v4 as uuidv4 } from 'uuid';
import { cloneDeep } from 'lodash-es';
@Component({
    selector: 'topo-contact-info-form',
    templateUrl: './contact-info-form.component.html',
    styleUrls: ['./contact-info-form.component.scss'],
    standalone: false
})
export class ContactInfoFormComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() isUserAccountLinked: boolean;
  @Input() set dataset(value: Dataset) {
    this._dataset = value;
    this.documentControls = [];
  }
  _dataset: Dataset;
  @Input() set editView(value: View) {
    if (!!value) {
      this.initEditView(value);
    }
  }
  @Input() document: Document;
  @Output() editProfileClicked = new EventEmitter<void>();
  @Output() documentChanged = new EventEmitter<any>();
  languages$: Observable<Language[]>;
  timezones: TZone[];
  documentControls: DynamicField[] = [];
  selectedViewContainer: ViewComponent;
  selectedViewControlContainerUId: string;
  workViewContainer: ViewComponent;
  personalViewContainer: ViewComponent;
  viewControlContainers: ViewComponent[] = [];
  guidEmpty = GUID_EMPTY;
  isEdit: boolean = true;
  editPrefsView: View;
  workPrefsView: View;
  personalPrefsView: View;
  currentChanges: any = {};

  hours = [
    [0, '12:00 AM'],
    [1, '1:00 AM'],
    [2, '2:00 AM'],
    [3, '3:00 AM'],
    [4, '4:00 AM'],
    [5, '5:00 AM'],
    [6, '6:00 AM'],
    [7, '7:00 AM'],
    [8, '8:00 AM'],
    [9, '9:00 AM'],
    [10, '10:00 AM'],
    [11, '11:00 AM'],
    [12, '12:00 PM'],
    [13, '1:00 PM'],
    [14, '2:00 PM'],
    [15, '3:00 PM'],
    [16, '4:00 PM'],
    [17, '5:00 PM'],
    [18, '6:00 PM'],
    [19, '7:00 PM'],
    [20, '8:00 PM'],
    [21, '9:00 PM'],
    [22, '10:00 PM'],
    [23, '11:00 PM']
  ];

  constructor(private store: Store, private timezoneService: TimezoneService, private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.languages$ = this.store.select(fromPrefs.selectLanguages);
    this.timezones = this.timezoneService.getTimezones();
  }

  viewContainerChanged(event: any) {
    this.selectedViewControlContainerUId = event;
    const newContainer = this.viewControlContainers.find(c => c.uId === this.selectedViewControlContainerUId);

    const updatedDocument = {
      ...this.document,
      ...this.currentChanges
    };

    this.document = updatedDocument;

    this.selectedViewContainer = newContainer;
    this.changeDetector.detectChanges();
  }

  workValueChanged(control: any) {
    if (!!!this.currentChanges) {
      this.currentChanges = {};
    }
    this.currentChanges[control.field.systemName] = control.value;
    this.documentChanged.emit(this.currentChanges);
    this.changeDetector.detectChanges();
  }

  personalValueChanged(control: any) {
    if (!!!this.currentChanges) {
      this.currentChanges = {};
    }
    this.currentChanges[control.field.systemName] = control.value;
    this.documentChanged.emit(this.currentChanges);
    this.changeDetector.detectChanges();
  }

  valueChanged(control: any) {
    if (!!!this.currentChanges) {
      this.currentChanges = {};
    }
    this.currentChanges[control.field.systemName] = control.value;
    this.documentChanged.emit(this.currentChanges);
    this.changeDetector.detectChanges();
  }


  private initEditView(editView: View): void {

    this.selectedViewControlContainerUId = null;

    if (editView?.controls?.some(c => c.controlType === ViewControlType.ViewControlContainer)) {
      this.viewControlContainers = editView.controls;
      this.selectedViewContainer = this.viewControlContainers.length > 0 ? this.viewControlContainers[0] : null;
      this.selectedViewControlContainerUId = this.selectedViewContainer?.uId;
    }

    this.editPrefsView = editView;

    this.workPrefsView = null;
    this.personalPrefsView = null;

    const workSection = this.viewControlContainers.find(c => c.name?.toLocaleLowerCase() == 'work');
    if (!!workSection) {
      this.workViewContainer = cloneDeep(workSection);
      this.workPrefsView = {
        uId: uuidv4(),
        controls: workSection.controls
      } as View;
    }

    const personalSection = this.viewControlContainers.find(c => c.name?.toLocaleLowerCase() == 'personal');
    if (!!personalSection) {
      this.personalViewContainer = cloneDeep(personalSection);
      this.personalPrefsView = {
        uId: uuidv4(),
        controls: personalSection.controls
      } as View;
    }

    this.changeDetector.detectChanges();
  }

  changeWorkEmail(event: any) {
    event.srcElement.blur();

    if (this.isUserAccountLinked) {
      return;
    }

    this.store.dispatch(fromPrefs.changeEmailField({ emailField: 'work_email' }));
  }

  changeWorkPhone(event: any) {
    event.srcElement.blur();

    this.store.dispatch(fromPrefs.changePhoneField({ phoneField: 'work_phone' }));
  }

  changePersonalEmail(event: any) {
    event.srcElement.blur();

    this.store.dispatch(fromPrefs.changeEmailField({ emailField: 'personal_email' }));
  }

  changePersonalPhone(event: any) {
    event.srcElement.blur();

    this.store.dispatch(fromPrefs.changePhoneField({ phoneField: 'personal_phone' }));
  }

  changeWhatsAppAddress(event: any) {
    event.srcElement.blur();

    this.store.dispatch(fromPrefs.changeWhatsAppField({ whatsAppField: 'whatsapp_address' }));
  }
}
